// @flow
import React from 'react';
import styled from 'styled-components';
import * as Layout from 'styles/Layout';
import { DROPDOWN_ALIGNMENT } from 'utils/Constants';
const { LEFT } = DROPDOWN_ALIGNMENT;

const Wrapper = styled(Layout.FlexColumn)`
  position: relative;
  height: 100%;
`;

const ToggleContainer = styled(Layout.FlexColumn)`
  height: 100%;
  cursor: pointer;
  background-color: ${props =>
    props.isOpen ? 'rgba(0, 0, 0, 0.07)' : 'transparent'};
  transition: background-color 0.2s linear;
  &:hover {
    background-color: rgba(0, 0, 0, 0.07);
  }
`;
const DropDownContainer = styled(Layout.FlexColumn)`
  position: absolute;
  top: 100%;
  ${props => props.alignment}: 0;
  min-width: 200px;
  overflow-y: hidden;
  max-height: ${props => (props.isOpen ? props.maxHeight + 'px' : '0')};
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  transition: max-height 0.2s ease-out;
  z-index: 5;
`;

type PropsType = {
  isOpenDropDown: boolean,
  BodyContainer: any,
  ButtonContainer: any,
  alignment?: string,
  visible?: boolean
};

type StateType = {
  isOpenDropDown: boolean,
  maxHeight: number
};

let contentDiv = null;
export default class ButtonDropDownComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    isOpenDropDown: false,
    maxHeight: 0
  };

  constructor(props: PropsType) {
    super(props);
    this.state = {
      isOpenDropDown: this.props.isOpenDropDown,
      maxHeight: 0
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('resize', this.updateDimensions);
  }

  handleClickOutside = (event: any) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.closeDropDown();
    }
  };

  updateDimensions = () => {
    if (
      contentDiv.scrollHeight !== this.state.maxHeight &&
      contentDiv.scrollHeight !== 0
    ) {
      this.setState({ maxHeight: contentDiv.scrollHeight });
    }
  };

  closeDropDown = () => {
    this.setState({ isOpenDropDown: false });
  };

  handleToggle = () => {
    if (!this.state.isOpenDropDown) this.updateDimensions();
    this.setState({ isOpenDropDown: !this.state.isOpenDropDown });
  };

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  render() {
    const {
      BodyContainer,
      ButtonContainer,
      alignment = LEFT,
      visible = true
    } = this.props;

    return (
      <div ref={this.setWrapperRef}>
        <Wrapper>
          <ToggleContainer
            isVisible={visible}
            onClick={() => this.handleToggle()}
            isOpen={this.state.isOpenDropDown}
          >
            <ButtonContainer />
          </ToggleContainer>
          <DropDownContainer
            innerRef={content => (contentDiv = content)}
            isOpen={this.state.isOpenDropDown}
            maxHeight={this.state.maxHeight}
            alignment={alignment}
            onClick={() => this.closeDropDown()}
          >
            <BodyContainer />
          </DropDownContainer>
        </Wrapper>
      </div>
    );
  }
}
